import React from "react";
import Dealers from "../DiamondLinks/Dealers";

const DiamondVendors = () => {
  return <Dealers type="Diamond Vendor" />;
};

export default DiamondVendors;
